import React from 'react'
import { STYLES_SIZE } from 'modules/styles/constants/index.cjs'
import { Image } from 'components/Image'

/**
 * @param name
 * @param source
 * @param size
 * @param width
 * @param shouldLazyLoad
 * @returns {JSX.Element}
 * @constructor
 */
export function Vignette ({
  name,
  source,
  size,
  width,
  shouldLazyLoad
}) {
  return (
    <Image
      alt={name}
      src={source}
      shouldLazyLoad={shouldLazyLoad}
      style={{
        width: size || width || '100%',
        boxSizing: 'border-box',
        overflow: 'hidden',
        borderRadius: '0.27em',
        minHeight: 'auto'
      }}
    />
  )
}

Vignette.SIZE = STYLES_SIZE
